import { OTA_Calculation } from "./ota_calculation.model";
import { OTA_TaxAmount } from "./ota_taxamount.model";

export class OTA_Charge {
    public amount: number;
    public amountNet: number;
    public amountTax: number;
    public currencyCode: string;
    public taxInclusive: boolean;
    public description: string;
    public includedInRate: boolean;
    public includedInEstTotalInd: boolean;
    public purpose: string;
    public taxAmounts = new Array<OTA_TaxAmount>();
    public calculations = new Array<OTA_Calculation>();

    static chargeTotal(chrg: OTA_Charge): number {
        var total: number = 0;

        total = total + chrg.amount;
        if (chrg.taxAmounts != null) {
            chrg.taxAmounts.forEach(function (txAmnt) {
                total = total + txAmnt.total;
            });
        }

        //if (chrg.calculations != null) {
        //    chrg.calculations.forEach(function (calc) {
        //        total = total + calc.total;
        //    });
        //}

        return total;
    }
}